import React from 'react'
import { Link } from 'gatsby'

import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';


const BetaPage = () => {

    return (
      <div style={{minHeight: '100vh', backgroundColor: '#eeeeee', textAlign: 'left' }} >
        <Toolbar style={{ justifyContent: 'space-between', alignItems: 'center',
            background: 'linear-gradient(to right,  #444464, #eeeeee)',
            boxShadow: '0 1px 20px #000000',
            borderRadius: '0 0 5px 5px'
        }}>
        <div>&nbsp;</div>
        <div style={{fontSize: '1.25rem', fontWeight: 'bold', color: '#FFFFFF',  textShadow: '2px 1px 3px #000033'}}>
            ceres e-commerce
        </div>

        <div style={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
          <Button variant='outlined' size='small' ><Link to='/home'> Sign in</Link></Button>
        </div>
        </Toolbar>

      <div style={{ margin: `0 auto`, padding: `10px 1.0rem 1.45rem`, maxWidth: 960, color: `#000000` }} >

      <Paper elevation={5} style={{clear: 'both'}}>
          <Box ml={4} mb={4} mt={1}>
              <Typography align='center'>
                Beta Program Sign-up
              </Typography>

              <Button variant='outlined' color='primary' size='small' ><Link to='/'> Back</Link></Button>
              <p>
              Our apologies, we have filled our first group of beta testers.
              </p>
              <p>
              Please check back with us, we plan on opening up a general beta soon!
              </p>
          </Box>

      <br /><br />
      </Paper>
      </div>
      </div>
    );
}

export default BetaPage


